import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { handleApiError } from "@utils/errorHandler";
import { ButtonContainer } from "./ContactAction.styled";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import activateIcon from "@icons/ic-activate.svg";
import AddEditRelatedContact from "../../../AddEditRelatedContact/AddEditRelatedContact";

const ContactAction = (props) => {
  const {
    t,
    data,
    onRefreshData,
    updateRefeshStatus,
    entityId,
    entityType,
    countryId,
  } = props;
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const [isEditMode, setIsEditMode] = useState(true);
  const [isViewMode, setIsViewMode] = useState(false);
  const [isEditContactPopupVisible, setIsEditContactPopupVisible] =
    useState(false);
  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState(
    "CONTACT_CONFIRMATION_BOX_DELETE"
  );
  const [confirmationBoxContent, setConfirmationBoxContent] = useState(
    "CONTACT_CONFIRMATION_BOX_DELETE_CONTENT"
  );

  const handleAnalyticalDisable = (status) => {
    if (status === 1) {
      setConfirmationBoxTitle("RELATED_CONTACT_CONFIRMATION_BOX_ENABLE");
      setConfirmationBoxContent(
        "RELATED_CONTACT_CONFIRMATION_BOX_ENABLE_CONTENT"
      );
    } else {
      setConfirmationBoxTitle("RELATED_CONTACT_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent(
        "RELATED_CONTACT_CONFIRMATION_BOX_DELETE_CONTENT"
      );
    }
    setConfirmVisibility(true);
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  useEffect(() => {
    if (isConfirm) {
      axios
        .post(
          `/relatedContact/${data.id}/updateStatus`,
          data.status === 1 ? `0` : 1
        )
        .then(() => {
          onRefreshData(true);
        })
        .catch((error) => handleApiError(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  const editContact = () => {
    setIsEditContactPopupVisible(true);
  };

  const closeContactEditPopup = () => {
    setIsEditContactPopupVisible(false);
  };

  return (
    <ButtonContainer>
      <div>
        {data.contactStatus === 1 && (
          <>
            <Image
              src={editIcon}
              title={t("CONTACT_ACTION_TOOLTIP_EDIT")}
              onClick={editContact}
              alt={t("CONTACT_ACTION_TOOLTIP_EDIT")}
              className="contact-notes-list__image-action-icon"
            />
            {!!data.status && (
              <Image
                src={deleteIcon}
                onClick={() => handleAnalyticalDisable(2)}
                alt={t("CONTACT_ACTION_TOOLTIP_DISABLE")}
                title={t("CONTACT_ACTION_TOOLTIP_DISABLE")}
                className="contact-notes-list__image-action-icon"
              />
            )}
            {!data.status && data.contactStatus && (
              <Image
                src={activateIcon}
                onClick={() => handleAnalyticalDisable(1)}
                alt={t("CONTACT_ACTION_TOOLTIP_ACTIVATE")}
                title={t("CONTACT_ACTION_TOOLTIP_ACTIVATE")}
                className="contact-notes-list__image-action-icon"
              />
            )}
          </>
        )}
        {isEditContactPopupVisible && (
          <AddEditRelatedContact
            id={data.id}
            title={t("EDIT_RELATED_CONTACT") + " #" + data.id}
            onClose={closeContactEditPopup}
            isEditMode={isEditMode}
            isViewMode={isViewMode}
            updateRefeshStatus={updateRefeshStatus}
            entityType={entityType}
            entityId={entityId}
            countryId={countryId}
          />
        )}
      </div>

      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </ButtonContainer>
  );
};

ContactAction.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
  onRefreshData: PropTypes.func.isRequired,
};
export default withTranslation()(ContactAction);
